import React, { useRef, useState } from 'react'
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import DashboardComp from './DashboardComp'

function Dashboard() {

  return (

    <div className='contentMain'> 
      <LeftBar/>
      <div className='theRightOne'> 
        <div className='DashTop'>
          <h1>Dashboard</h1>
          <NavBar/>
        </div>
        <DashboardComp/>

      </div>    
    </div>
  )
}

export default Dashboard